module.exports = __webpack_public_path__ + "static/media/icon-calendar-grey.57fc16e2.svg";